import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, createElementVNode as _createElementVNode, unref as _unref, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5d585a02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "header-message" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "icon" }),
  /*#__PURE__*/_createElementVNode("div", { class: "text" }, " 该平台端口由极飞科技监察委员会独立管理，若您知悉任何极飞员工在商业活动中存在的违法、违规或者不正当的行为，您可以通过此页面提交举报，举报时请尽量协助提供相关证据，以便我们进行调查核实，感谢您对极飞反舞弊工作的支持与信任。 ")
], -1))
const _hoisted_3 = { class: "upload-wrap" }
const _hoisted_4 = { class: "upload-image-list" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "相关证据资料。", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "tips" }, [
  /*#__PURE__*/_createTextVNode(" 图片、聊天记录、转账记录等证据资料; "),
  /*#__PURE__*/_createElementVNode("span", null, "文件大小不超过20M")
], -1))
const _hoisted_7 = { class: "success-popup" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "icon" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, "您的信息已提交", -1))
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "message" }, "感谢您对极飞的支持", -1))

import type { FormInstance } from 'vant'
import { clearToast, showNormalToast, showToastLoading } from '@/utils/tools'
import { getUrlFileBaseInfo } from '@/utils/common'
import { createSupervisionReport } from '@/apis/public'
import type { UploadFileDataItem } from '@/types/public'
import { commonErrorHandle } from '@/utils/error-handle'
import { Form, Field, CellGroup, ActionSheet, Popup, Text } from 'vant'
import { computed, onMounted, onUnmounted, reactive, ref } from 'vue'
import AppHeader from '@/components/Header.vue'
import NoticeOnReporting from './components/notice-on-reporting.vue'
import UploadFileGroup from '@/components/upload-new/UploadFileGroup.vue'
import CommonFooterNextButton from '@/components/CommonFooterNextButton.vue'
import PcAuditForm from './components/pc-audit-form.vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'supervisopn-reporting',
  setup(__props) {

const fromValue = reactive({
  useType: '',
  isAnonymous: '',
  userContract: '',
  isNeedFeedback: '',
  feedbackContract: '',
  complaintName: '',
  complaintPosition: '',
  fileInfos: [],
  complaintContent: '',
})
const popupShow = ref(false)
const noticePopupShow = ref(true)
const formVm = ref<FormInstance>()
const formKey = ref(Math.random())
const windowWidth = ref(window.innerWidth)
const pcFormKey = ref(Date.now())

const rulesConfig = {
  complaintContent: [{ required: true, message: '请输入投诉内容' }],
  complaintName: [{ required: true, message: '请输入投诉对象姓名' }],
  complaintPosition: [{ required: true, message: '请输入投诉对象职务' }],
}

const anonymousActionConfig = reactive({
  show: false,
  actions: [
    { name: '是', subname: '' },
    { name: '否', subname: '希望您留下您的联系方式， 我们对举报人的信息将严格保密。' },
  ],
})
const showAnonymous = computed(() => {
  return fromValue.isAnonymous === '否'
})
const isUsePhoneLayout = computed(() => {
  return windowWidth.value <= 750
})
const useTypeConfig = reactive({
  show: false,
  actions: [
    { name: '员工' },
    { name: '供应商' },
    { name: '合作伙伴/客户' },
    { name: '投资人/股东' },
    { name: '前员工' },
    { name: '外部人员' },
  ],
})
const feedbackConfig = reactive({
  show: false,
  actions: [
    { name: '是', subname: '若需要调查反馈请输入正确的联系方式，以便我们与您取得联系。' },
    { name: '否', subname: '' },
  ],
})
const showFeedbackContract = computed(() => {
  return fromValue.isNeedFeedback === '是'
})

function anonymousSelectHandle(data: { name: string }) {
  fromValue.isAnonymous = data.name
}

function userTypeSelectHandle(data: { name: string }) {
  fromValue.useType = data.name
}
function feedbackSelectHandle(data: { name: string }) {
  fromValue.isNeedFeedback = data.name
}

function beforeSubmit() {
  formVm.value?.submit()

  // submitHandle()
}
function uploadFileChange(data: UploadFileDataItem[]) {
  fromValue.fileInfos = data.map((item) => ({
    ...item,
    // status: 'uploading',
  }))
  formVm.value?.validate('fileInfos')
}
function pcSubmitHandle() {
  let message = ''
  if (!fromValue.complaintName) {
    message = '请输入投诉对象'
  } else if (!fromValue.complaintPosition) {
    message = '请输入投诉对象职务'
  } else if (!fromValue.complaintContent) {
    message = '请输入投诉内容'
  }
  if (message) {
    showNormalToast(message)
    return
  }

  submitHandle()
}
async function submitHandle() {
  try {
    showToastLoading()
    await createSupervisionReport({
      role: fromValue.useType,
      phone: fromValue.userContract || '',
      feedback_phone: fromValue.feedbackContract || '',
      complaint_object: fromValue.complaintName,
      position: fromValue.complaintPosition,
      complaint_content: fromValue.complaintContent,
      annex_list: fromValue.fileInfos.map((item) => {
        const suffix = getUrlFileBaseInfo(item.key).suffix
        return {
          uri: item.key,
          file_name: (item?.file?.name || '文件上传').replace(`.${suffix}`, ''),
          suffix,
        }
      }),
    })
    fromValue.useType = ''
    fromValue.isAnonymous = ''
    fromValue.userContract = ''
    fromValue.isNeedFeedback = ''
    fromValue.feedbackContract = ''
    fromValue.complaintName = ''
    fromValue.complaintPosition = ''
    fromValue.complaintContent = ''
    fromValue.fileInfos = []
    formKey.value = Math.random()
    clearToast()
    popupShow.value = true
    pcFormKey.value = Date.now()
  } catch (error) {
    commonErrorHandle(error)
  }
}
function submitFailHandle(errorInfo: { values: any; errors: any[] }) {
  console.log('errorInfo', errorInfo)
}
function updateWindowWidth() {
  const width = window.innerWidth
  windowWidth.value = width
}
function pcFormChange(data: { field: keyof typeof fromValue; value: string }) {
  fromValue[data.field] = data?.value as any
}
onMounted(() => {
  window.addEventListener('resize', updateWindowWidth)
})
onUnmounted(() => {
  window.removeEventListener('resize', updateWindowWidth)
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(AppHeader, {
      title: "监督举报",
      useDefaultHeader: ""
    }),
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      (_unref(isUsePhoneLayout))
        ? (_openBlock(), _createBlock(_unref(Form), {
            class: "form-wrap",
            "label-width": "160px",
            "input-align": "right",
            "error-message-align": "right",
            ref_key: "formVm",
            ref: formVm,
            onSubmit: submitHandle,
            onFailed: submitFailHandle,
            key: formKey.value
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(CellGroup), { inset: "" }, {
                default: _withCtx(() => [
                  _createVNode(_unref(Field), {
                    modelValue: fromValue.useType,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((fromValue.useType) = $event)),
                    label: "你是谁?",
                    name: "useType",
                    placeholder: "请选择",
                    "is-link": "",
                    readonly: "",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (useTypeConfig.show = true))
                  }, null, 8, ["modelValue"]),
                  _createVNode(_unref(Field), {
                    modelValue: fromValue.isAnonymous,
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((fromValue.isAnonymous) = $event)),
                    label: "是否匿名?",
                    name: "isAnonymous",
                    placeholder: "请选择",
                    "is-link": "",
                    readonly: "",
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (anonymousActionConfig.show = true))
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createVNode(_unref(Field), {
                    modelValue: fromValue.userContract,
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((fromValue.userContract) = $event)),
                    label: "联系方式",
                    name: "userContract",
                    placeholder: "请输入您的联系方式"
                  }, null, 8, ["modelValue"]), [
                    [_vShow, _unref(showAnonymous)]
                  ]),
                  _createVNode(_unref(Field), {
                    modelValue: fromValue.isNeedFeedback,
                    "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((fromValue.isNeedFeedback) = $event)),
                    label: "是否需要调查结果反馈?",
                    name: "isNeedFeedback",
                    placeholder: "请选择",
                    "is-link": "",
                    readonly: "",
                    onClick: _cache[6] || (_cache[6] = ($event: any) => (feedbackConfig.show = true))
                  }, null, 8, ["modelValue"]),
                  _withDirectives(_createVNode(_unref(Field), {
                    modelValue: fromValue.feedbackContract,
                    "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((fromValue.feedbackContract) = $event)),
                    label: "联系方式",
                    name: "feedbackContract",
                    placeholder: "请输入您的联系方式"
                  }, null, 8, ["modelValue"]), [
                    [_vShow, _unref(showFeedbackContract)]
                  ]),
                  _createVNode(_unref(Field), {
                    modelValue: fromValue.complaintName,
                    "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((fromValue.complaintName) = $event)),
                    label: "投诉对象",
                    name: "complaintName",
                    required: "",
                    placeholder: "请输入",
                    rules: rulesConfig.complaintName
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_unref(Field), {
                    modelValue: fromValue.complaintPosition,
                    "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((fromValue.complaintPosition) = $event)),
                    required: "",
                    label: "投诉对象职务",
                    name: "complaintPosition",
                    placeholder: "请输入",
                    rules: rulesConfig.complaintPosition
                  }, null, 8, ["modelValue", "rules"]),
                  _createVNode(_unref(Field), {
                    modelValue: fromValue.complaintContent,
                    "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((fromValue.complaintContent) = $event)),
                    required: "",
                    label: "投诉内容",
                    rows: "3",
                    name: "complaintContent",
                    type: "textarea",
                    placeholder: "请输入",
                    rules: rulesConfig.complaintContent
                  }, null, 8, ["modelValue", "rules"]),
                  _createElementVNode("div", _hoisted_3, [
                    _createVNode(_unref(Field), {
                      name: "fileInfos",
                      readonly: ""
                    }, {
                      input: _withCtx(() => [
                        _createElementVNode("div", _hoisted_4, [
                          _hoisted_5,
                          _hoisted_6,
                          _createVNode(UploadFileGroup, {
                            useAction: false,
                            uploadTo: "integrated",
                            fileSizeLimit: 20480,
                            fileSizeLimitMessage: "存在单个文件大小超过20M",
                            onChange: uploadFileChange
                          })
                        ])
                      ]),
                      _: 1
                    })
                  ])
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(PcAuditForm, {
            class: "pc-form",
            key: pcFormKey.value,
            anonymousActions: anonymousActionConfig.actions,
            userTypeOptions: useTypeConfig.actions,
            feedbackOptions: feedbackConfig.actions,
            formData: fromValue,
            onChange: pcFormChange
          }, null, 8, ["anonymousActions", "userTypeOptions", "feedbackOptions", "formData"])),
      (!_unref(isUsePhoneLayout))
        ? (_openBlock(), _createElementBlock("div", {
            key: 2,
            class: "pc-submit-button",
            onClick: pcSubmitHandle
          }, "提交"))
        : _createCommentVNode("", true),
      _createVNode(_unref(ActionSheet), {
        show: anonymousActionConfig.show,
        "onUpdate:show": _cache[11] || (_cache[11] = ($event: any) => ((anonymousActionConfig.show) = $event)),
        "close-on-click-action": "",
        actions: anonymousActionConfig.actions,
        teleport: "body",
        "cancel-text": "取消",
        onSelect: anonymousSelectHandle
      }, null, 8, ["show", "actions"]),
      _createVNode(_unref(ActionSheet), {
        show: useTypeConfig.show,
        "onUpdate:show": _cache[12] || (_cache[12] = ($event: any) => ((useTypeConfig.show) = $event)),
        "close-on-click-action": "",
        teleport: "body",
        actions: useTypeConfig.actions,
        "cancel-text": "取消",
        onSelect: userTypeSelectHandle
      }, null, 8, ["show", "actions"]),
      _createVNode(_unref(ActionSheet), {
        show: feedbackConfig.show,
        "onUpdate:show": _cache[13] || (_cache[13] = ($event: any) => ((feedbackConfig.show) = $event)),
        "close-on-click-action": "",
        actions: feedbackConfig.actions,
        teleport: "body",
        "cancel-text": "取消",
        onSelect: feedbackSelectHandle
      }, null, 8, ["show", "actions"])
    ]),
    (_unref(isUsePhoneLayout))
      ? (_openBlock(), _createBlock(CommonFooterNextButton, {
          key: 0,
          title: "提交",
          fullBtn: "",
          class: "footer-button-item",
          onClick: beforeSubmit
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(Popup), {
      show: popupShow.value,
      "onUpdate:show": _cache[15] || (_cache[15] = ($event: any) => ((popupShow).value = $event)),
      round: ""
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "close",
            onClick: _cache[14] || (_cache[14] = ($event: any) => (popupShow.value = false))
          }),
          _hoisted_8,
          _hoisted_9,
          _hoisted_10
        ])
      ]),
      _: 1
    }, 8, ["show"]),
    _createVNode(_unref(Popup), {
      show: noticePopupShow.value,
      "onUpdate:show": _cache[17] || (_cache[17] = ($event: any) => ((noticePopupShow).value = $event)),
      round: "",
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createVNode(NoticeOnReporting, {
          onClose: _cache[16] || (_cache[16] = ($event: any) => (noticePopupShow.value = false))
        })
      ]),
      _: 1
    }, 8, ["show"])
  ], 64))
}
}

})